import { getI18NText } from 'I18N';
import { isValidAddress } from 'components/forms/address/AddressForm';
import { MAX_PO_ATTACHMENT_SIZE } from 'utils/constants/checkout';

const addressHeaderId = 'billing-page-header';

export const validateCheckoutBilling = (
  billingData
): {
  isAllDataValid: boolean;
  billingErrors: any;
  focusOnElement: string;
} => {
  let focusOnElement = '';
  let billingErrors: {
    address?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    poNumber?: string;
    poLength?: string;
  } = {};
  const { billingAddress, poFile, poNumber } = billingData;
  const isValidBillAddress = isValidAddress(billingAddress);
  const isPoNumberValid = poNumber && poNumber.trim();
  const isPoLengthValid = !poFile?.fileData || poFile?.fileSize <= MAX_PO_ATTACHMENT_SIZE;

  if (!isValidBillAddress.isValid) {
    focusOnElement = addressHeaderId;
    billingErrors = isValidBillAddress.errors;
  }

  if (!isPoLengthValid) {
    billingErrors.poLength = getI18NText('PO_ATTACHMENT_SIZE_ERROR_MESSAGE');
  }

  if (!isPoNumberValid) {
    billingErrors.poNumber = getI18NText('PO_NUMBER_ERROR_MESSAGE');
  }

  return {
    isAllDataValid: Boolean(isValidBillAddress.isValid && isPoNumberValid && isPoLengthValid),
    focusOnElement,
    billingErrors,
  };
};
